import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "./components/accordion.js";
import "./components/gallery.js";
import "./components/menuMobile.js";

import "../styles/interieurdesigner.css";

handleFloatingPromise(initExpertSite());
